import { render, staticRenderFns } from "./ModalPesquisarMedicamento.vue?vue&type=template&id=8afd3832&scoped=true"
import script from "./ModalPesquisarMedicamento.vue?vue&type=script&lang=ts"
export * from "./ModalPesquisarMedicamento.vue?vue&type=script&lang=ts"
import style0 from "./ModalPesquisarMedicamento.vue?vue&type=style&index=0&id=8afd3832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afd3832",
  null
  
)

export default component.exports